angular.module('unergie.main')
.factory('JiraService', ($q, ApiAdmin, BoFeaturesService, DataAccessVariables, JiraConstants, JiraSearch) => {
    const getSelectableEpics = (epics) => {
        const jiraIssuesVisibility = BoFeaturesService.getModuleFeatures('jiraIssuesVisibility')
        return _.filter(epics, (e) => _.map(e.fields.customfield_10829, (field) => jiraIssuesVisibility[field.value]).includes(true))
    }

    const getRequestTypes = (organization) => {
        return ApiAdmin.getRequestTypes({ projectName: organization }).$promise
    }

    const getNewJiraIssueTemplate = (type) => {
        if (type === 'PDL' || type === 'B2G') {
            return {
                summary: undefined,
                type: 'Support',
                requestType: undefined,
                description: undefined,
                prm: undefined,
            }
        }

        return {
            summary: undefined,
            issuetype: 'Task',
            type: 'Task',
            epic: undefined,
            priority: undefined,
            description: undefined,
            prm: undefined,
            sensitive: false,
            idCase: undefined,
            reminderCustomerCallback: null,
            reminder: null,
        }
    }

    const getNewJiraIssueFields = (type) => {
        if (type === 'PDL') {
            return {
                summary: {
                    type: 'text',
                    label: 'Résumé',
                    required: true,
                },
                epic: {
                    type: 'select',
                    label: 'Motif',
                    enum: [],
                    required: true,
                },
                description: {
                    type: 'textarea',
                    label: 'Description',
                    required: true,
                },
            }
        } else if (type === 'B2G') {
            return {
                summary: {
                    type: 'text',
                    label: 'Titre *',
                    required: true,
                },
                requestType: {
                    type: 'select',
                    label: 'Motif *',
                    enum: [],
                    required: true,
                },
                prm: {
                    type: 'text',
                    label: 'Numéro point de livraison',
                    required: false,
                },
                description: {
                    type: 'textarea',
                    label: 'Description *',
                    required: true,
                },
            }
        }

        return {
            summary: {
                type: 'text',
                label: 'Résumé',
                required: true,
                check: (template) => { return template.summary !== template.initialSummary },
            },
            summaryCheck: {
                hidden: (template) => { return template.summary != null && template.summary !== '' && template.summary !== template.initialSummary },
                label: '<span class="red"><span class="fa fa-warning"></span>Complétez le titre</span>',
                type: 'label',
            },
            epic: {
                type: 'select',
                label: 'Motif',
                enum: [],
                check: (template) => {
                    const epicName = _.get(template, 'epic.fields.epicName', '')
                    const isCustomerCallback = epicName.match(/rappel client/i)
                    const isTrackRecord = epicName.match(/suivi de dossier/i)

                    template.selfAssign = !!(isCustomerCallback || isTrackRecord)

                    return !!epicName
                },
            },
            epicCheck: {
                hidden: (template) => { return template.epic != null },
                label: '<span class="red"><span class="fa fa-warning"></span>Choisissez une catégorie</span>',
                type: 'label',
            },
            priority: {
                type: 'radio',
                label: 'Priorité',
                enum: JiraConstants.priorityEnum,
                required: true,
            },
            priorityCheck: {
                hidden: (template) => { return template.priority != null },
                label: '<span class="red"><span class="fa fa-warning"></span>Précisez la priorité</span>',
                type: 'label',
            },
            description: {
                type: 'textarea',
                label: 'Description',
                required: true,
            },
            descriptionCheck: {
                hidden: (template) => { return template.description != null && template.description !== '' },
                label: '<span class="red"><span class="fa fa-warning"></span>Remplissez une description</span>',
                type: 'label',
            },
            sensitive: {
                type: 'checkbox',
                label: 'Dossier sensible',
            },
            idCase: {
                type: 'text',
                label: 'Affaire SGE',
            },
            reminderCustomerCallback: {
                type: 'datetime',
                label: 'Rappel client (date / heure)',
                required: (template) => {
                    return !!_.get(template, 'epic.fields.epicName', '').match(/rappel client/i)
                },
                hidden: (template) => {
                    return !_.get(template, 'epic.fields.epicName', '').match(/rappel client/i)
                },
            },
            reminder: {
                type: 'date',
                label: 'Rappel client',
                required: (template) => {
                    return !!_.get(template, 'epic.fields.epicName', '').match(/suivi de dossier/i)
                },
                hidden: (template) => {
                    return !!_.get(template, 'epic.fields.epicName', '').match(/rappel client/i)
                },
            },
            reminderCheck: {
                hidden: (template) => {
                    return (!_.get(template, 'epic.fields.epicName', '').match(/rappel client/i) || template.reminderCustomerCallback != null)
                        && (!_.get(template, 'epic.fields.epicName', '').match(/suivi de dossier/i) || template.reminder != null)
                },
                label: '<span class="red"><span class="fa fa-warning"></span>Précisez la date de rappel</span>',
                type: 'label',
            },
        }
    }

    const newJiraIssueInitialData = (type) => {
        return {
            text: 'Créer un nouveau ticket de suivi interne',
            fields: getNewJiraIssueFields(type),
            template: getNewJiraIssueTemplate(type),
            buttonlabel: 'Enregistrer',
        }
    }

    const init = (epics, type, accounts) => {
        const newJiraIssue = newJiraIssueInitialData(type)
        let epicEnum
        let brandEnum
        let requestTypeEnum
        if (type === 'PDL') {
            epicEnum = _.map(epics, (e) => ({ label: e.name, value: e }))
            delete newJiraIssue.fields.priority
        } else if (type === 'B2G') {
            if (accounts.length > 1) {
                brandEnum = _.map(_.values(accounts), (account) => ({
                    label: account.brand,
                    value: { customer_id: account.customer_id, brand: account.brand },
                }))
                newJiraIssue.fields.brand = {
                    type: 'select',
                    label: `Nom d'adherent`,
                    enum: [],
                    required: true,
                }
                newJiraIssue.fields.brand.enum = brandEnum
            } else if (accounts.length > 0) {
                newJiraIssue.template.brand = { brand: accounts[0].brand, customer_id: accounts[0].customer_id }
            }

            requestTypeEnum = _.map(_.values(epics), (e) => ({ label: e.name, value: e }))
            newJiraIssue.fields.requestType.enum = requestTypeEnum
            return newJiraIssue
        } else {
            epicEnum = _.map(getSelectableEpics(_.values(epics)), (e) => ({ label: e.fields.epicName, value: e }))
        }
        newJiraIssue.fields.epic.enum = epicEnum

        return newJiraIssue
    }

    const computeDateFilter = (key, value, toReturn) => {
        const operatorsMap = {
            '>=': 'gte',
            '<=': 'lte',
            '<': 'lt',
            '>': 'gt',
            '': 'eq',
        }
        const operator = _.keys(operatorsMap).find((op) => value.indexOf(op) === 0)
        toReturn[operatorsMap[operator]].push(`${key}=${value.substring(operator.length)}`)
    }

    const computeOperator = (key, value, toReturn) => {
        if (value.indexOf('!') === 0) {
            if (value.length > 1) {
                toReturn.notin.push(`${key}=${value.substring(1)}`)
            }
        } else if (value.indexOf(',') > -1) {
            if (value.length > 1) {
                toReturn.in.push(`${key}=${value}`)
            }
        } else if (value === 'null') {
            toReturn.notexists.push(`${key}`)
        } else {
            const field = ['requestType', 'key', 'status', 'issuetype', 'epicLink', 'complaintLevel', 'resolution'].indexOf(key) === -1 ? 'like' : 'eq'
            toReturn[field].push(`${key}=${value}`)
        }
    }

    const computeFilters = (params, toReturn) => {
        const filters = params.filter()
        if (filters) {
            _.forEach(_.keys(filters), (key) => {
                if (filters[key] !== '') {
                    // jira fields do not support any type of operator
                    if ((key === 'created' || key === 'updated') && filters[key].length >= 10) {
                        computeDateFilter(key, filters[key], toReturn)
                    } else if (key !== 'created') {
                        computeOperator(key, filters[key], toReturn)
                    }
                }
            })
        }
    }


    const computeSort = (params, toReturn) => {
        toReturn.sortObj = params.sorting()
        if (toReturn.sortObj && (Object.keys(toReturn.sortObj).length > 0)) {
            toReturn.orderBy = _.map(toReturn.sortObj, (orderBy, sortKey) => `${orderBy === 'desc' ? '-' : ''}${sortKey}`).join(',')
        }
    }

    const computeHeaders = (params, startAt, maxResults) => {
        const toReturn = {
            search: {},
            filterObj: {},
            gt: [],
            gte: [],
            lt: [],
            lte: [],
            neq: [],
            eq: [],
            notin: [],
            in: [],
            like: [],
            unlike: [],
            null: [],
            notnull: [],
            exists: [],
            notexists: [],
            columns: [],
            offset: params.offset,
            limit: params.limit,
        }

        if (params.page && params.count) {
            toReturn.offset = (params.page() - 1) * params.count()
            toReturn.limit = params.count()
        }
        if (params.filter) {
            computeFilters(params, toReturn)
        }
        if (params.sorting) {
            computeSort(params, toReturn)
        }

        return toReturn
    }

    const getData = (params, projectName, fields) => {
        const headers = computeHeaders(params)
        headers.search = {
            projectName,
        }
        if (fields) {
            headers.search.fields = fields
        }
        return JiraSearch(headers).searchPaginated(headers.search)
    }

    const getAssigned = (params, projectName, fields) => {
        const headers = computeHeaders(params)
        headers.search = {
            projectName,
        }
        if (fields) {
            headers.search.fields = fields
        }
        return JiraSearch(headers).searchAssignedPaginated(headers.search)
    }

    const getUnassigned = (params, projectName, fields) => {
        const headers = computeHeaders(params)
        headers.search = {
            projectName,
        }
        if (fields) {
            headers.search.fields = fields
        }
        return JiraSearch(headers).searchUnassignedPaginated(headers.search)
    }
    const getPostponed = (params, projectName, fields) => {
        const headers = computeHeaders(params)
        headers.search = {
            projectName,
        }
        if (fields) {
            headers.search.fields = fields
        }
        return JiraSearch(headers).searchPostponedPaginated(headers.search)
    }

    let getEpicsPromise = null

    const getEpics = () => {
        if (getEpicsPromise) {
            return getEpicsPromise
        }
        const params = {}
        params.filter = () => ({
            issuetype: 'Epic',
        })
        getEpicsPromise = getData(params, 'support,exploit').$promise
        .then((response) => {
            return _.keyBy(response.results.issues, 'key')
        })
        return getEpicsPromise
    }

    const attachmentCommentCleaner = (comment) => {
        return comment.replace(/(.*)[\s\S]*\[\^(?:public_|internal_)([^\]]*)\](.*)/m, '$1$2$3')
    }

    return {
        getData,
        getAssigned,
        getUnassigned,
        getPostponed,
        getEpics,
        getNewJiraIssueTemplate,
        getRequestTypes,
        getSelectableEpics,
        newJiraIssueInitialData,
        init,
        attachmentCommentCleaner,
    }
})
